module.exports = __webpack_public_path__ + "img/n4.c7abb3a7.png";